exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-html-viewer[data-v-75bc6647]{height:100%;display:flex;flex-direction:column}.fts-html-viewer .html-viewer-iframe[data-v-75bc6647]{height:100%;display:flex;flex-direction:column;overflow:auto;color:var(--fts-text)}.fts-html-viewer .export-btn[data-v-75bc6647]{position:fixed;top:1rem;right:1rem}", ""]);

// exports
